import { useRecoilState } from 'recoil';
import { Store } from '../store';

export const useTypography = () => {
  const [typography, setTypography] = useRecoilState(Store.typographySettings);
  return { typography, setTypography };
};
